// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Intro_container__ptHaU {
  padding-top: 200px;
}
.Intro_container__ptHaU .Intro_wrapper__eDfMy {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #e0e0e0;
  position: relative;
  width: 100%;
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_intro_pic__bo8Bp {
  width: auto;
  height: 100%;
  max-width: 50%;
  object-fit: cover;
}
.Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_title__-FUrz {
  font-weight: 500;
  font-size: 36px;
  text-transform: uppercase;
  font-family: "DrukWideCyr_medium";
}
.Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_title__-FUrz .Intro_yellow__ubIeh {
  color: #ead40c;
}
.Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_info__JrfE3 {
  line-height: 1.15;
  margin-top: 24px;
  width: 100%;
}
.Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_info__JrfE3 .Intro_txt__B9rxt {
  margin-top: 8px;
  font-weight: 400;
  font-size: 20px;
}
.Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_btn__NKXij {
  display: block;
  margin-top: 24px;
}
.Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_btn__NKXij button {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  background-color: #fd4c0a;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  width: 111px;
  height: 46px;
  padding: 0 22px;
  transition: background-color 0.3s;
}

@media (max-width: 850px) {
  .Intro_container__ptHaU {
    padding-top: 104px;
  }
  .Intro_container__ptHaU .Intro_wrapper__eDfMy {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
  }
  .Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_intro_pic__bo8Bp {
    width: auto;
    height: 100%;
    max-width: 100%;
    object-fit: cover;
    margin-top: 40px;
  }
  .Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_title__-FUrz {
    font-size: 20px;
  }
  .Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_info__JrfE3 {
    font-size: 16px;
    width: 100%;
  }
  .Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_btn__NKXij {
    width: 111px;
    height: 46px;
  }
  .Intro_container__ptHaU .Intro_wrapper__eDfMy .Intro_btn__NKXij button {
    width: 100%;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Welcome/Intro/Intro.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAGE;ECsCA,eAAA;EACA,gBAAA;EACA,kBAAA;EDrCE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAAN;AAGI;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iCAAA;AADN;AAGM;EACE,cAAA;AADR;AAKI;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;AAHN;AAKM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAHR;AAOI;EACE,cAAA;EACA,gBAAA;AALN;AAOM;ECFJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDGM,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAJR;;AAcA;EACE;IACE,kBAAA;EAXF;EAaE;IACE,WAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;EAXJ;EAaI;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;EAXN;EAcI;IACE,eAAA;EAZN;EAeI;IACE,eAAA;IACA,WAAA;EAbN;EAgBI;IACE,YAAA;IACA,YAAA;EAdN;EAeM;IACE,WAAA;IACA,uBAAA;EAbR;AACF","sourcesContent":["@import \"../../../assets/styles/global.scss\";\n\n.container {\n  padding-top: 200px;\n\n  .wrapper {\n    @include subtitle5;\n\n    color: #e0e0e0;\n    position: relative;\n    width: 100%;\n    z-index: 2;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    .intro_pic {\n      width: auto;\n      height: 100%;\n      max-width: 50%;\n      object-fit: cover;\n    }\n\n    .title {\n      font-weight: 500;\n      font-size: 36px;\n      text-transform: uppercase;\n      font-family: \"DrukWideCyr_medium\";\n\n      .yellow {\n        color: #ead40c;\n      }\n    }\n\n    .info {\n      line-height: 1.15;\n      margin-top: 24px;\n      width: 100%;\n\n      .txt {\n        margin-top: 8px;\n        font-weight: 400;\n        font-size: 20px;\n      }\n    }\n\n    .btn {\n      display: block;\n      margin-top: 24px;\n\n      button {\n        @include subtitle6m;\n\n        align-items: center;\n        background-color: #fd4c0a;\n        border-radius: 8px;\n        cursor: pointer;\n        display: flex;\n        gap: 8px;\n        width: 111px;\n        height: 46px;\n        padding: 0 22px;\n        transition: background-color 0.3s;\n\n        // &:hover {\n        //   background-color: darken(#ead40c, 10%);\n        // }\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    padding-top: 104px;\n\n    .wrapper {\n      width: 100%;\n      flex-direction: column;\n      align-items: flex-start;\n      justify-content: space-between;\n\n      .intro_pic {\n        width: auto;\n        height: 100%;\n        max-width: 100%;\n        object-fit: cover;\n        margin-top: 40px;\n      }\n\n      .title {\n        font-size: 20px;\n      }\n\n      .info {\n        font-size: 16px;\n        width: 100%;\n      }\n\n      .btn {\n        width: 111px;\n        height: 46px;\n        button {\n          width: 100%;\n          justify-content: center;\n        }\n      }\n    }\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Intro_container__ptHaU`,
	"wrapper": `Intro_wrapper__eDfMy`,
	"intro_pic": `Intro_intro_pic__bo8Bp`,
	"title": `Intro_title__-FUrz`,
	"yellow": `Intro_yellow__ubIeh`,
	"info": `Intro_info__JrfE3`,
	"txt": `Intro_txt__B9rxt`,
	"btn": `Intro_btn__NKXij`
};
export default ___CSS_LOADER_EXPORT___;
